import {Link, useNavigate} from '@shopify/hydrogen';
import {useState} from 'react';

type Props = {
  onClose: () => void;
};

export default function SearchNavGroupContent({onClose}: Props) {
  const navigate = useNavigate();
  const [path, setPath] = useState<string>('')

  const handleValue = (e: any) => {
    setPath(e.target.value)
  }

  const handlePath = (str: string) => {
    return '/search/' + str
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
  }

  const handleEnter = (e: any) => {
    if (e.keyCode === 13 && path.length >= 3) {
      navigate(handlePath(path), {replace: true})
      onClose()
    }
  }

  return (
    <div className="grid--main pt-footer">
      <div style={{ gridArea: '1/13/2/17' }}>
        <form
          className="relative"
          onSubmit={handleSubmit}
          onKeyDown={handleEnter}
        >
          <input
            type="text"
            placeholder='Type anything…'
            value={path}
            onChange={handleValue}
            className="text-small placeholder:text-gray w-full text-black"
          />
          <div className='h-[1px] bg-gray w-full mt-2 mb-10 w-full' />
          <div className="mt-20">
            <button
              className="w-fit text-main border-main border px-10 py-2 hover:bg-main hover:text-white disabled:cursor-not-allowed disabled:text-gray disabled:border-gray disabled:hover:bg-white"
              disabled={path.length < 3 ? true : false}
            >
              {path.length >= 3 ?
                <Link
                  to={handlePath(path)}
                  onClick={onClose}
                >
                  Search
                </Link>
                : <p>Search</p>
              }
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}